// Parse duration string to seconds for sorting
export const parseDuration = (duration) => {
  const [mins, secs] = duration.split(':').map(Number);
  return mins * 60 + secs;
};

// Comparator for sorting
export function descendingComparator(a, b, orderBy) {
  let aVal = a[orderBy];
  let bVal = b[orderBy];
  
  // Special handling for duration (sort numerically)
  if (orderBy === 'duration') {
    aVal = parseDuration(aVal);
    bVal = parseDuration(bVal);
  }
  
  if (bVal < aVal) return -1;
  if (bVal > aVal) return 1;
  return 0;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}